import { Data } from './localDB';

export const getNestedValue = (obj: any, path: string) => {
    const keys = path.split('.');
    let nestedValue = obj;

    for (const key of keys) {
        if (nestedValue && typeof nestedValue === 'object' && key in nestedValue) {
            nestedValue = nestedValue[key];
        } else {
            return undefined; // Property not found
        }
    }

    return nestedValue;
}

export const listMapWithProperty = (totalMaps: Data[], property: string) => {
    const mapWithProperty: number[] = [];
    for (const map of totalMaps) {
        const value = getNestedValue(map.snippet, property);
        if (value !== undefined || !property) {
            mapWithProperty.push(map.id);
        }
    }

    return mapWithProperty;
}

export const valueOfProperty = (totalMaps: Data[], property: string) => {
    const values: Record<string, any> = {};
    for (const map of totalMaps) {
        const value = getNestedValue(map.snippet, property);
        if (value !== undefined) {
            values[value] = values[value] ? [...values[value], map.id] : [map.id];
        }
    }

    return values
}

export const getAuthorFromProperty = (totalMaps: Data[]) => {
    const authors: Record<string, any> = {};
    for (const map of totalMaps) {
        authors[map.author.name] = authors[map.author.name] ? [...authors[map.author.name], map.id] : [map.id];
    }

    return authors;
}

export const getValueWithMapId = (totalMaps: Data[], property: string) => {
    const results = listMapWithProperty(totalMaps, property);

    const tmp = [];
    for (const mapId of results) {
        const map = totalMaps.find((map) => map.id === mapId);
        if (map) {
            const value = getNestedValue(map.snippet, property);
            tmp.push({
                mapId,
                [property]: value
            })
        }
    }

    return tmp;
}
